/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 16 16" }, this.props),
            React.createElement("path", { d: "m15.773244 9.75173858-6.02150542 6.02150542c-.30234138.3023413-.79253363.3023413-1.09487501 0l-8.43010753-8.43010757c-.14518945-.14518945-.22675604-.34210861-.22675604-.54743751v-6.02150537c0-.42757529.34661826-.77419355.77419355-.77419355h6.02150537c.2053289 0 .40224806.08156659.54743751.22675604l8.43010757 8.43010753c.3023413.30234138.3023413.79253363 0 1.09487501zm-1.6423126-.5474375-7.65591394-7.65591398h-4.92663036v4.92663036l7.65591398 7.65591394zm-9.14168409-2.40860216c-.99716129 0-1.80645161-.80929032-1.80645161-1.80645161 0-.99625806.80929032-1.80645161 1.80645161-1.80645161.99806452 0 1.80645161.81019355 1.80645161 1.80645161 0 .99716129-.80838709 1.80645161-1.80645161 1.80645161z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;